import gql from 'graphql-tag';
import { graphql as graphQL } from 'react-apollo';import { deleteJobMatch } from '../../graphql/default';

export const withDeleteJobMatch = (Component) => {
	return graphQL(gql(deleteJobMatch), {
		props: (props) => ({
			onDeleteJobMatch(input) {
				const optimisticResponseData = {
					...props.jobMatch,
					...input.input,
				};
				props.mutate({
					variables: input,
					optimisticResponse: {
						__typeName: 'Mutation',
						deleteContact: {
							...optimisticResponseData,
							__typeName: 'deleteJobMatch',
						},
					},
				});
			},
		}),
	})(Component);
};
